import React, { useEffect, useState } from 'react';
import Button from '../../ReusableComponents/Button';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getClientsUnderProcess } from '../../slices/creditRiskSlice';
import Tooltip from '../../ReusableComponents/Tooltip';

const ListAction = ({
  type,
  title,
  text,
  isAction,
  actionText,
  action,
  isPurchasable,
  companyId,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { isAgingFileUploaded } = useSelector((state) => state.creditRisk);

  const [timer, setTimer] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [toolTipText, setToolTipText] = useState('');

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(timer - 1);
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [timer]);

  useEffect(() => {
    if (companyId && timer === 0 && isAgingFileUploaded) {
      dispatch(getClientsUnderProcess(companyId));
      setTimer(15);
    }
  }, [dispatch, timer, isAgingFileUploaded, companyId]);

  const onGetClientsUnderProcess = () => {
    companyId && dispatch(getClientsUnderProcess(companyId));
    setTimer(15);
  };

  const iconRenderer = () => {
    return type === `processing` ? (
      <svg
        width='12'
        height='12'
        viewBox='0 0 12 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_9338_6332)'>
          <path
            d='M7.125 1.125C7.125 0.826631 7.00647 0.540483 6.7955 0.329505C6.58452 0.118526 6.29837 0 6 0C5.70163 0 5.41548 0.118526 5.2045 0.329505C4.99353 0.540483 4.875 0.826631 4.875 1.125C4.875 1.42337 4.99353 1.70952 5.2045 1.9205C5.41548 2.13147 5.70163 2.25 6 2.25C6.29837 2.25 6.58452 2.13147 6.7955 1.9205C7.00647 1.70952 7.125 1.42337 7.125 1.125ZM7.125 10.875C7.125 10.5766 7.00647 10.2905 6.7955 10.0795C6.58452 9.86853 6.29837 9.75 6 9.75C5.70163 9.75 5.41548 9.86853 5.2045 10.0795C4.99353 10.2905 4.875 10.5766 4.875 10.875C4.875 11.1734 4.99353 11.4595 5.2045 11.6705C5.41548 11.8815 5.70163 12 6 12C6.29837 12 6.58452 11.8815 6.7955 11.6705C7.00647 11.4595 7.125 11.1734 7.125 10.875ZM1.125 7.125C1.42337 7.125 1.70952 7.00647 1.9205 6.7955C2.13147 6.58452 2.25 6.29837 2.25 6C2.25 5.70163 2.13147 5.41548 1.9205 5.2045C1.70952 4.99353 1.42337 4.875 1.125 4.875C0.826631 4.875 0.540483 4.99353 0.329505 5.2045C0.118526 5.41548 0 5.70163 0 6C0 6.29837 0.118526 6.58452 0.329505 6.7955C0.540483 7.00647 0.826631 7.125 1.125 7.125ZM12 6C12 5.70163 11.8815 5.41548 11.6705 5.2045C11.4595 4.99353 11.1734 4.875 10.875 4.875C10.5766 4.875 10.2905 4.99353 10.0795 5.2045C9.86853 5.41548 9.75 5.70163 9.75 6C9.75 6.29837 9.86853 6.58452 10.0795 6.7955C10.2905 7.00647 10.5766 7.125 10.875 7.125C11.1734 7.125 11.4595 7.00647 11.6705 6.7955C11.8815 6.58452 12 6.29837 12 6ZM3.34922 10.2422C3.45371 10.1377 3.5366 10.0136 3.59315 9.87712C3.6497 9.74059 3.67881 9.59426 3.67881 9.44648C3.67881 9.29871 3.6497 9.15238 3.59315 9.01585C3.5366 8.87933 3.45371 8.75527 3.34922 8.65078C3.24473 8.54629 3.12067 8.4634 2.98415 8.40685C2.84762 8.3503 2.70129 8.32119 2.55352 8.32119C2.25507 8.32119 1.96885 8.43975 1.75781 8.65078C1.54678 8.86182 1.42822 9.14804 1.42822 9.44648C1.42822 9.74493 1.54678 10.0312 1.75781 10.2422C1.96885 10.4532 2.25507 10.5718 2.55352 10.5718C2.85196 10.5718 3.13819 10.4532 3.34922 10.2422ZM3.34922 3.34688C3.4589 3.2436 3.54673 3.11934 3.60748 2.98148C3.66823 2.84362 3.70068 2.69496 3.70289 2.54432C3.7051 2.39368 3.67703 2.24413 3.62035 2.10455C3.56367 1.96496 3.47953 1.83818 3.37292 1.73173C3.26631 1.62528 3.13941 1.54133 2.99974 1.48485C2.86007 1.42838 2.71048 1.40053 2.55985 1.40296C2.40921 1.40539 2.2606 1.43806 2.12283 1.49901C1.98505 1.55997 1.86093 1.64798 1.75781 1.75781C1.54678 1.96885 1.42822 2.25507 1.42822 2.55352C1.42822 2.85196 1.54678 3.13819 1.75781 3.34922C1.96885 3.56025 2.25507 3.67881 2.55352 3.67881C2.85196 3.67881 3.13819 3.56025 3.34922 3.34922V3.34688ZM8.65078 10.2422C8.75527 10.3467 8.87933 10.4296 9.01585 10.4861C9.15238 10.5427 9.29871 10.5718 9.44648 10.5718C9.59426 10.5718 9.74059 10.5427 9.87712 10.4861C10.0136 10.4296 10.1377 10.3467 10.2422 10.2422C10.3467 10.1377 10.4296 10.0136 10.4861 9.87712C10.5427 9.74059 10.5718 9.59426 10.5718 9.44648C10.5718 9.29871 10.5427 9.15238 10.4861 9.01585C10.4296 8.87933 10.3467 8.75527 10.2422 8.65078C10.1377 8.54629 10.0136 8.4634 9.87712 8.40685C9.74059 8.3503 9.59426 8.32119 9.44648 8.32119C9.29871 8.32119 9.15238 8.3503 9.01585 8.40685C8.87933 8.4634 8.75527 8.54629 8.65078 8.65078C8.54629 8.75527 8.4634 8.87933 8.40685 9.01585C8.3503 9.15238 8.32119 9.29871 8.32119 9.44648C8.32119 9.59426 8.3503 9.74059 8.40685 9.87712C8.4634 10.0136 8.54629 10.1377 8.65078 10.2422Z'
            fill='#D97706'
          />
        </g>
        <defs>
          <clipPath id='clip0_9338_6332'>
            <rect width='12' height='12' fill='white' />
          </clipPath>
        </defs>
      </svg>
    ) : type === `High` ? (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='8' cy='8' r='8' fill='#FEE2E2' />
        <circle cx='8' cy='8' r='4' fill='#B91C1C' />
      </svg>
    ) : type === `Medium` ? (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='8' cy='8' r='8' fill='#FEF3C7' />
        <circle cx='8' cy='8' r='4' fill='#D97706' />
      </svg>
    ) : type === `Low` ? (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='8' cy='8' r='8' fill='#DCFCE7' />
        <circle cx='8' cy='8' r='4' fill='#15803D' />
      </svg>
    ) : type === `Minimal` ? (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle cx='8' cy='8' r='8' fill='#DFEFFF' />
        <circle cx='8' cy='8' r='4' fill='#356EB1' />
      </svg>
    ) : (
      <svg
        width='12'
        height='12'
        viewBox='0 0 12 12'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M6 12C7.5913 12 9.11742 11.3679 10.2426 10.2426C11.3679 9.11742 12 7.5913 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0C4.4087 0 2.88258 0.632141 1.75736 1.75736C0.632141 2.88258 0 4.4087 0 6C0 7.5913 0.632141 9.11742 1.75736 10.2426C2.88258 11.3679 4.4087 12 6 12ZM6 3C6.31172 3 6.5625 3.25078 6.5625 3.5625V6.1875C6.5625 6.49922 6.31172 6.75 6 6.75C5.68828 6.75 5.4375 6.49922 5.4375 6.1875V3.5625C5.4375 3.25078 5.68828 3 6 3ZM5.25 8.25C5.25 8.05109 5.32902 7.86032 5.46967 7.71967C5.61032 7.57902 5.80109 7.5 6 7.5C6.19891 7.5 6.38968 7.57902 6.53033 7.71967C6.67098 7.86032 6.75 8.05109 6.75 8.25C6.75 8.44891 6.67098 8.63968 6.53033 8.78033C6.38968 8.92098 6.19891 9 6 9C5.80109 9 5.61032 8.92098 5.46967 8.78033C5.32902 8.63968 5.25 8.44891 5.25 8.25Z'
          fill='#1E293B'
        />
      </svg>
    );
  };

  const onHover = (type) => {
    setIsHovered(true);
    setToolTipText(`reveal_${type?.toLowerCase()}`);
  };

  const onBlur = () => {
    setIsHovered(false);
    setToolTipText('');
  };

  return (
    <div
      className={`list_action list_action_${type}`}
      onMouseEnter={() => onHover(type)}
      onMouseLeave={onBlur}
    >
      {iconRenderer()}
      <div className='text'>
        {text} {`${t(`clients`)}:`}
      </div>
      <div className='title'>{title}</div>
      {type === `processing` && (
        <>
          <svg
            width='28'
            height='28'
            viewBox='0 0 28 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='list_action_processing_icon'
            onClick={onGetClientsUnderProcess}
          >
            <g filter='url(#filter0_d_10458_5830)'>
              <path
                d='M2 7C2 3.68629 4.68629 1 8 1H20C23.3137 1 26 3.68629 26 7V19C26 22.3137 23.3137 25 20 25H8C4.68629 25 2 22.3137 2 19V7Z'
                fill='white'
                shapeRendering='crispEdges'
              />
              <path
                d='M2.5 7C2.5 3.96243 4.96243 1.5 8 1.5H20C23.0376 1.5 25.5 3.96243 25.5 7V19C25.5 22.0376 23.0376 24.5 20 24.5H8C4.96243 24.5 2.5 22.0376 2.5 19V7Z'
                stroke='#E4E4E7'
                shapeRendering='crispEdges'
              />
              <g clipPath='url(#clip0_10458_5830)'>
                <path
                  d='M10.4633 11.7484C10.6437 11.2375 10.9367 10.757 11.3492 10.3469C12.8141 8.88204 15.1883 8.88204 16.6531 10.3469L17.0539 10.75H16.25C15.8352 10.75 15.5 11.0852 15.5 11.5C15.5 11.9148 15.8352 12.25 16.25 12.25H18.8633H18.8727C19.2875 12.25 19.6227 11.9148 19.6227 11.5V8.87501C19.6227 8.46016 19.2875 8.12501 18.8727 8.12501C18.4578 8.12501 18.1227 8.46016 18.1227 8.87501V9.70001L17.7125 9.28751C15.6617 7.23672 12.3383 7.23672 10.2875 9.28751C9.71562 9.85938 9.30312 10.532 9.05 11.2516C8.91172 11.643 9.11797 12.0695 9.50703 12.2078C9.89609 12.3461 10.325 12.1399 10.4633 11.7508V11.7484ZM8.91406 13.7805C8.79688 13.8156 8.68437 13.8789 8.59297 13.9727C8.49922 14.0664 8.43594 14.1789 8.40313 14.3008C8.39609 14.3289 8.38906 14.3594 8.38437 14.3898C8.37734 14.4297 8.375 14.4695 8.375 14.5094V17.125C8.375 17.5398 8.71016 17.875 9.125 17.875C9.53984 17.875 9.875 17.5398 9.875 17.125V16.3023L10.2875 16.7125C12.3383 18.7609 15.6617 18.7609 17.7102 16.7125C18.282 16.1406 18.6969 15.468 18.95 14.7484C19.0883 14.357 18.882 13.9305 18.493 13.7922C18.1039 13.6539 17.675 13.8602 17.5367 14.2492C17.3562 14.7602 17.0633 15.2406 16.6508 15.6508C15.1859 17.1156 12.8117 17.1156 11.3469 15.6508L11.3445 15.6484L10.9437 15.25H11.75C12.1648 15.25 12.5 14.9148 12.5 14.5C12.5 14.0852 12.1648 13.75 11.75 13.75H9.13438C9.09688 13.75 9.05937 13.7523 9.02187 13.757C8.98437 13.7617 8.94922 13.7688 8.91406 13.7805Z'
                  fill='#334155'
                />
              </g>
            </g>
            <defs>
              <filter
                id='filter0_d_10458_5830'
                x='0'
                y='0'
                width='28'
                height='28'
                filterUnits='userSpaceOnUse'
                colorInterpolationFilters='sRGB'
              >
                <feFlood floodOpacity='0' result='BackgroundImageFix' />
                <feColorMatrix
                  in='SourceAlpha'
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                  result='hardAlpha'
                />
                <feOffset dy='1' />
                <feGaussianBlur stdDeviation='1' />
                <feComposite in2='hardAlpha' operator='out' />
                <feColorMatrix
                  type='matrix'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0'
                />
                <feBlend
                  mode='normal'
                  in2='BackgroundImageFix'
                  result='effect1_dropShadow_10458_5830'
                />
                <feBlend
                  mode='normal'
                  in='SourceGraphic'
                  in2='effect1_dropShadow_10458_5830'
                  result='shape'
                />
              </filter>
              <clipPath id='clip0_10458_5830'>
                <rect
                  width='12'
                  height='12'
                  fill='white'
                  transform='translate(8 7)'
                />
              </clipPath>
            </defs>
          </svg>
          {timer}s
        </>
      )}
      {isAction && (
        <span className='list_user_action'>
          <Button
            type='seven'
            text={actionText}
            onClickHandler={() => action(type, isPurchasable)}
          />
          {isPurchasable && (
            <svg
              width='12'
              height='12'
              viewBox='0 0 12 12'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
              className='dollar_icon'
            >
              <rect width='12' height='12' rx='6' fill='#15803D' />
              <path
                d='M6.01272 1.99844C6.28928 1.99844 6.51272 2.22188 6.51272 2.49844V3.05626C6.53772 3.05938 6.56116 3.06251 6.58616 3.06719C6.59241 3.06876 6.59709 3.06876 6.60334 3.07032L7.35334 3.20782C7.62522 3.25782 7.80491 3.51876 7.75491 3.78907C7.70491 4.05938 7.44397 4.24063 7.17366 4.19063L6.43147 4.05469C5.94241 3.98282 5.51116 4.03126 5.20803 4.15157C4.90491 4.27188 4.78303 4.43751 4.75491 4.59063C4.72366 4.75782 4.74709 4.85157 4.77366 4.90938C4.80178 4.97032 4.85959 5.03907 4.97366 5.11563C5.22834 5.28282 5.61897 5.39219 6.12522 5.52657L6.17053 5.53907C6.61741 5.65782 7.16428 5.80157 7.57053 6.06719C7.79241 6.21251 8.00178 6.40938 8.13147 6.68438C8.26428 6.96407 8.29241 7.27657 8.23147 7.60938C8.12366 8.20313 7.71428 8.60001 7.20647 8.80782C6.99241 8.89532 6.75959 8.95157 6.51272 8.97969V9.50157C6.51272 9.77813 6.28928 10.0016 6.01272 10.0016C5.73616 10.0016 5.51272 9.77813 5.51272 9.50157V8.95626C5.50647 8.95469 5.49866 8.95469 5.49241 8.95313H5.48928C5.10803 8.89376 4.48147 8.72969 4.05959 8.54219C3.80803 8.42969 3.69397 8.13438 3.80647 7.88282C3.91897 7.63126 4.21428 7.51719 4.46584 7.62969C4.79241 7.77501 5.32991 7.91876 5.64084 7.96719C6.13928 8.04063 6.55022 7.99844 6.82834 7.88438C7.09241 7.77657 7.21272 7.62032 7.24709 7.43282C7.27678 7.26719 7.25334 7.17188 7.22678 7.11407C7.19709 7.05157 7.13928 6.98282 7.02366 6.90626C6.76741 6.73907 6.37522 6.62969 5.86741 6.49532L5.82366 6.48438C5.37834 6.36251 4.83147 6.21719 4.42522 5.95157C4.20334 5.80626 3.99553 5.60782 3.86584 5.33282C3.73459 5.05313 3.70803 4.74063 3.77053 4.40782C3.88303 3.81094 4.32991 3.42344 4.83772 3.22188C5.04553 3.13907 5.27366 3.08282 5.51272 3.05001V2.49844C5.51272 2.22188 5.73616 1.99844 6.01272 1.99844Z'
                fill='white'
              />
            </svg>
          )}
        </span>
      )}
      <Tooltip
        from='credit_risk_list_action'
        isVisible={isHovered}
        text={toolTipText}
        position={'center'}
      />
    </div>
  );
};

export default ListAction;
